import { api } from './api';

export type ExportScope = 'company' | 'user';
export type ExportStatus =
  | 'pending'
  | 'generating'
  | 'ready'
  | 'failed'
  | 'expired';

export interface DataExport {
  id: string;
  companyId: string;
  requestedBy: string;
  scope: ExportScope;
  targetUserId: string | null;
  status: ExportStatus;
  sizeBytes: number | null;
  expiresAt: string | null;
  errorMessage: string | null;
  createdAt: string;
  completedAt: string | null;
}

/** Base URL for the download endpoint — caller may navigate directly. */
function downloadUrl(id: string): string {
  const base =
    (import.meta.env.VITE_API_URL as string | undefined) ||
    'http://localhost:3000';
  return `${base}/api/gdpr/exports/${id}/download`;
}

export const gdprApi = {
  async requestCompanyExport(companyId: string): Promise<DataExport> {
    const r = await api.post<DataExport>('/api/gdpr/exports/company', {
      companyId,
    });
    return r.data;
  },
  async requestUserExport(userId?: string): Promise<DataExport> {
    const r = await api.post<DataExport>(
      '/api/gdpr/exports/user',
      userId ? { userId } : {},
    );
    return r.data;
  },
  /** Open the download in a new tab — keeps cookies in place. */
  download(id: string): void {
    window.open(downloadUrl(id), '_blank', 'noopener,noreferrer');
  },
  async deleteCompany(
    companyId: string,
    confirmationPhrase: string,
  ): Promise<void> {
    await api.delete(`/api/gdpr/company/${companyId}`, {
      data: { confirmationPhrase },
    });
  },
  async deleteUser(
    userId: string,
    confirmationPhrase: string,
  ): Promise<void> {
    await api.delete(`/api/gdpr/user/${userId}`, {
      data: { confirmationPhrase },
    });
  },
};
